import {createSlice, PayloadAction} from '@reduxjs/toolkit'

export interface TokenState {
    token: string
}

const tokenInitialState: TokenState = {
    token: ''
}

const tokenSlice = createSlice({
    name: 'token',
    initialState: tokenInitialState,
    reducers: {
        setToken(state, action: PayloadAction<string>) {
            state.token =  action.payload
        }
    }
})

export const { setToken } = tokenSlice.actions
export default tokenSlice.reducer
